import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"

export default function MarkdownMessage({ content }: { content: string }) {
    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
                p: ({ children }) => <p className={"mb-2 last:mb-0"}>{children}</p>,
                strong: ({ children }) => (
                    <strong className={"font-semibold text-inherit"}>{children}</strong>
                ),
                em: ({ children }) => <em className={"italic"}>{children}</em>,
                h1: ({ children }) => (
                    <h1 className={"mb-2 mt-3 text-base font-bold"}>{children}</h1>
                ),
                h2: ({ children }) => (
                    <h2 className={"mb-1.5 mt-3 text-sm font-bold"}>{children}</h2>
                ),
                h3: ({ children }) => (
                    <h3 className={"mb-1 mt-2 text-sm font-semibold"}>{children}</h3>
                ),
                ul: ({ children }) => (
                    <ul className={"mb-2 ml-4 list-disc space-y-0.5"}>{children}</ul>
                ),
                ol: ({ children }) => (
                    <ol className={"mb-2 ml-4 list-decimal space-y-0.5"}>{children}</ol>
                ),
                li: ({ children }) => <li className={"text-sm"}>{children}</li>,
                code: ({ children }) => (
                    <code className={"rounded bg-gray-200 px-1 py-0.5 text-xs font-mono text-gray-800"}>
                        {children}
                    </code>
                ),
                hr: () => <hr className={"my-2 border-gray-300"} />,
            }}
        >
            {content}
        </ReactMarkdown>
    )
}
